const markers = [
  { markerOffset: 0, name: "Algiers", coordinates: [3.0588, 36.7538] },
  { markerOffset: 0, name: "Atlanta", coordinates: [-84.388, 33.749] },
  { markerOffset: 0, name: "Baghdad", coordinates: [44.3661, 33.3152] },
  { markerOffset: 0, name: "Bangkok", coordinates: [100.5018, 13.7563] },
  { markerOffset: 0, name: "Beijing", coordinates: [116.4074, 39.9042] },
  { markerOffset: 0, name: "Bogota", coordinates: [-74.0721, 4.711] },
  { markerOffset: 0, name: "Buenos_Aires", coordinates: [-58.3816, -34.6037] },
  { markerOffset: 0, name: "Cairo", coordinates: [31.2357, 30.0444] },
  { markerOffset: 0, name: "Chennai", coordinates: [80.2707, 13.0827] },
  { markerOffset: 0, name: "Chicago", coordinates: [-87.6298, 41.8781] },
  { markerOffset: 0, name: "Delhi", coordinates: [77.1025, 28.7041] },
  { markerOffset: 0, name: "Essen", coordinates: [7.0116, 51.4556] },
  {
    markerOffset: 0,
    name: "Ho_Chi_Minh_City",
    coordinates: [106.6297, 10.8231]
  },
  { markerOffset: 0, name: "Hong_Kong", coordinates: [114.1095, 22.3964] },
  { markerOffset: 0, name: "Istanbul", coordinates: [28.9784, 41.0082] },
  { markerOffset: 0, name: "Jakarta", coordinates: [106.8283, -6.1805] },
  { markerOffset: 0, name: "Johannesburg", coordinates: [28.0473, -26.2041] },
  { markerOffset: 0, name: "Karachi", coordinates: [67.0011, 24.8607] },
  { markerOffset: 0, name: "Khartoum", coordinates: [32.5599, 15.5007] },
  { markerOffset: 0, name: "Kinshasa", coordinates: [15.2663, -4.4419] },
  { markerOffset: 0, name: "Kolkata", coordinates: [88.3639, 22.5726] },
  { markerOffset: 0, name: "Lagos", coordinates: [3.3792, 6.5244] },
  { markerOffset: 0, name: "Lima", coordinates: [-77.0428, -12.0464] },
  { markerOffset: 0, name: "London", coordinates: [-0.1278, 51.5074] },
  { markerOffset: 0, name: "Los_Angeles", coordinates: [-118.2437, 34.0522] },
  { markerOffset: 0, name: "Madrid", coordinates: [-3.7038, 40.4168] },
  { markerOffset: 0, name: "Manila", coordinates: [120.9842, 14.5995] },
  { markerOffset: 0, name: "Mexico_City", coordinates: [-99.1332, 19.4326] },
  { markerOffset: 0, name: "Miami", coordinates: [-80.1918, 25.7617] },
  { markerOffset: 0, name: "Milan", coordinates: [9.19, 45.4642] },
  { markerOffset: 0, name: "Montreal", coordinates: [-73.5673, 45.5017] },
  { markerOffset: 0, name: "Moscow", coordinates: [37.6173, 55.7558] },
  { markerOffset: 0, name: "Mumbai", coordinates: [72.8777, 19.076] },
  { markerOffset: 0, name: "New_York", coordinates: [-74.006, 40.7128] },
  { markerOffset: 0, name: "Osaka", coordinates: [135.5022, 34.6937] },
  { markerOffset: 0, name: "Paris", coordinates: [2.3522, 48.8566] },
  { markerOffset: 0, name: "Riyadh", coordinates: [46.6753, 24.7136] },
  { markerOffset: 0, name: "San_Francisco", coordinates: [-122.4194, 37.7749] },
  { markerOffset: 0, name: "Santiago", coordinates: [-70.6693, -33.4489] },
  { markerOffset: 0, name: "Sao_Paulo", coordinates: [-46.6333, -23.5505] },
  { markerOffset: 0, name: "Seoul", coordinates: [126.978, 37.5665] },
  { markerOffset: 0, name: "Shanghai", coordinates: [121.4737, 31.2304] },
  { markerOffset: 0, name: "St_Petersburg", coordinates: [30.3351, 59.9343] },
  { markerOffset: 0, name: "Sydney", coordinates: [151.2093, -33.8688] },
  { markerOffset: 0, name: "Taipei", coordinates: [121.5654, 25.033] },
  { markerOffset: 0, name: "Tehran", coordinates: [51.389, 35.6892] },
  { markerOffset: 0, name: "Tokyo", coordinates: [139.6917, 35.6895] },
  { markerOffset: 0, name: "Washington", coordinates: [-77.0369, 38.9072] }
];

export default markers;
// 30.3351, 59.9343
